/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeadvancedhint2Inputs */

const en_placeadvancedhint2 = /** @type {(inputs: Placeadvancedhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories, coordinates, shortcuts, buttons in the app`)
};

const de_placeadvancedhint2 = /** @type {(inputs: Placeadvancedhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorien, Koordinaten, Schnellzugriff, Knöpfe in der App`)
};

/**
* | output |
* | --- |
* | "Categories, coordinates, shortcuts, buttons in the app" |
*
* @param {Placeadvancedhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeadvancedhint2 = /** @type {((inputs?: Placeadvancedhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeadvancedhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeadvancedhint2(inputs)
	return de_placeadvancedhint2(inputs)
});
export { placeadvancedhint2 as "placeAdvancedHint" }